<template>
  <div class="welcome-message">
    <img alt="icon" src="~@/static/icon.png" />
  </div>
</template>
<script>
export default {
  name: "welcome",
  methods: {}
};
</script>

<style lang="scss" scoped>
.welcome-message {
  display: table-cell !important;
  height: 100%;
  text-align: center;
  vertical-align: middle;

  & > img {
    width: 12rem;
    margin-top: 10rem;
  }
}
</style>
